import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Order matters. duelapi.css is the design system and owns the ground, the
// frame, the tiles and the dock; theme.css adds the data colours and the few
// components that only a tracker-comparison site needs.
import './styles/fonts.css';
import './styles/duelapi.css';
import './styles/reports.css';
import './styles/theme.css';
import './styles/glass.css';
import './styles/compare.css';
import './styles/controls.css';
import './styles/pages.css';

import { App } from './app/App';

const host = document.getElementById('root');
if (!host) throw new Error('#root is missing from index.html');

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
